/**
 * Công bố chính sách dùng AI của bài cho học viên (TT 83 C5; TT 56 Đ24.2 — dùng AI trái phép
 * là gian lận nên SV phải biết rõ trước khi làm).
 */
import { Alert, Space, Tag, Typography } from "antd";

import { MarkdownContent } from "@/components/MarkdownContent";
import { AI_LEVEL_COLOR, AI_LEVEL_LABEL, type StudentAiPolicy } from "@/features/ai/aiPolicy";

const { Text } = Typography;

export function AiPolicyNotice({ policy }: { policy: StudentAiPolicy | null | undefined }) {
  if (!policy) return null;
  return (
    <Alert
      type={policy.level === "prohibited" ? "warning" : "info"}
      showIcon
      style={{ marginBottom: 16 }}
      data-testid="ai-policy-notice"
      message={
        <Space wrap>
          <span>Chính sách sử dụng AI:</span>
          <Tag color={AI_LEVEL_COLOR[policy.level]}>{AI_LEVEL_LABEL[policy.level]}</Tag>
          {policy.tutor_blocked && <Tag>AI Tutor tạm khoá khi làm bài</Tag>}
        </Space>
      }
      description={
        <>
          {policy.student_notice && <MarkdownContent source={policy.student_notice} />}
          {policy.allowed_tools && (
            <Text type="secondary">Công cụ được phép: {policy.allowed_tools}</Text>
          )}
          {policy.declaration_required && (
            <div>
              <Text type="secondary">Bạn sẽ khai báo việc sử dụng AI khi nộp bài.</Text>
            </div>
          )}
        </>
      }
    />
  );
}
